import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography, Paper, Alert, Snackbar } from '@mui/material';
import NotificationsForm from './NotificationsForm';
import { fetchNotifications } from './notificationsSlice';

const NotificationsPage = () => {
    const dispatch = useDispatch();
    const notificationsState = useSelector((state) => state.notifications);
    const { users } = notificationsState;

    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState('');
    const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');

    useEffect(() => {
        dispatch(fetchNotifications());
    }, [dispatch]);

    const onSendNotifications = async (result) => {
        const status = result?.status || 'sent';
        const ticketsOk = result?.tickets_ok || 0;
        const requestErrors = result?.request_errors || 0;
        const ticketErrors = result?.tickets_error || 0;
        const invalidTokens = result?.invalid_tokens || 0;
        const totalErrors = requestErrors + ticketErrors;

        if (status === 'partial' || totalErrors > 0 || invalidTokens > 0) {
            setSnackbarMessage(`Envío parcial: ${ticketsOk} tickets OK, ${totalErrors} errores, ${invalidTokens} tokens inválidos.`);
            setSnackbarSeverity('warning');
        } else {
            setSnackbarMessage(`Notificaciones procesadas correctamente. Tickets OK: ${ticketsOk}.`);
            setSnackbarSeverity('success');
        }

        setSnackbarOpen(true);
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    return (
        <Paper elevation={3} style={{ padding: '20px', marginTop: '20px' }}>
            <Typography variant="h4" gutterBottom>
                Panel de Control de Notificaciones
            </Typography>
            <NotificationsForm onSendNotifications={onSendNotifications} users={users} />
            <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Paper>
    );
};

export default NotificationsPage;
